import api, { METHODS } from './api'

export default async function getKeepScreenshotAfterProcessFlag(): Promise<boolean> {
    try {
        const keepScreenshotAfterProcessFlag = await api<{keepScreenshotAfterProcessFlag: boolean}>(
            `keepScreenshotAfterProcessFlag`, // for apache servers
            METHODS.GET
        )

        return keepScreenshotAfterProcessFlag.keepScreenshotAfterProcessFlag
    } catch (error) {
        // TODO: use logger
        // console.error(error)
        console.error("Could not get the current set flag to keep the screenshot cache after the report's process", error)
        
        return false
    }
}